<template>
  <div class="back" style="padding: 20px">
    <el-row type="flex" class="row-bg" justify="space-between">
      <!-- <el-col :span="3">
        <el-card shadow="hover" style="  cursor: pointer;">
          <div class="warpbaox" @click="clickData">
            <div class="user">
              <i class="el-icon-s-data" style="font-size:52px;color:#ffff"></i>
            </div>
            <div class="count">
              <div style="font-size:18px; !important;color:#66b1ff;">
                实时数据
              </div>
              <div class="name"></div>
            </div>
          </div>
        </el-card>
      </el-col>-->

      <el-col :span="4">
        <el-card shadow="hover">
          <div class="warpbaox">
            <div class="user">
              <i
                class="el-icon-set-up"
                style="font-size: 52px; color: #ffff"
              ></i>
            </div>
            <div class="count">
              <div class="nub">{{ topTab.devicecount }}</div>
              <div class="name">{{ dataObjs.quanbushebei }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover">
          <div class="warpbaox" style="background: #64d572">
            <div class="user">
              <i
                class="el-icon-success"
                style="font-size: 52px; color: #ffff"
              ></i>
            </div>
            <div class="count">
              <div class="nub">{{ topTab.onlinecount }}</div>
              <div class="name">{{ dataObjs.zaixianshebei }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover">
          <div class="warpbaox" style="background: #f25e43">
            <div class="user">
              <i
                class="el-icon-error"
                style="font-size: 52px; color: #ffff"
              ></i>
            </div>
            <div class="count hovEnt" @click="delciEnt('lixian')">
              <div class="nub">{{ topTab.offlinecount }}</div>
              <div style="color: #f25e43" class="name">
                {{ dataObjs.lixianshebei }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover">
          <div class="warpbaox" style="background: rgb(47, 67, 85)">
            <div class="user">
              <i
                class="el-icon-message-solid"
                style="font-size: 52px; color: rgb(242, 94, 67)"
              ></i>
            </div>
            <div class="count hovEnt">
              <div class="nub">{{ topTab.alarmcount }}</div>
              <div class="name">{{ dataObjs.baojingshebei }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover">
          <div class="warpbaox" style="background: #b56742">
            <div class="user">
              <i
                class="el-icon-warning"
                style="font-size: 52px; color: #ffff"
              ></i>
            </div>
            <div class="count hovEnt" @click="delciEnt('guzhang')">
              <div class="nub">{{ topTab.errorcount }}</div>
              <div class="name">{{ dataObjs.canshuguzhang }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="ditu">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <div class="myMal">
            {{ dataObjs.wangguanxinxi }}

            <div class="selectOnints" v-if="roletype == 0">
              <!-- <span>展开级别:</span> -->
              <el-select
                v-model="valueinsts"
                placeholder="请选择展开级别"
                style="width: 140px; margin-left: 15px; heigth: 30px"
                @change="mycityHande"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <el-card class="bodt" style="background: #">
            <!-- <echartsBing/> -->
            <tree
              :defaulttree="defaultTree"
              ref="Tabtree"
              @getUuidclick="getUuidclick"
              @countClickTree="countClickTree"
            />
          </el-card>
        </el-col>
        <el-col :span="13" style="padding: 0 5px">
          <div class="myMal">
            {{ dataObjs.dituxinxi }}
            <!-- <el-tooltip class="item" effect="dark" content="最大化" placement="top">
                <img
                  src="@/assets/img/ck.png"
                  style="width:35px;height:20px"
                  @click="lishData('地图信息')"
                  alt="窗口化"
                />
            </el-tooltip>-->
          </div>
          <el-card class="bodtConetne">
            <mapT class="mapList" />
          </el-card>
        </el-col>
        <el-col :span="6">
          <div class="myMal">{{ dataObjs.shebeixinxi }}</div>
          <el-card class="bodt">
            <!-- <echartsHx/> -->
            <echartsBing :topobjdata="topTab" ref="echartsBing" />
            <!-- rightTabl -->
            <!-- <div class="tble" v-for="(item) in rightTabl" :key="item.id">
              {{item.name}}
            </div>-->
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-between">
        <el-col :span="6">
          <div class="myMal">{{ dataObjs.shishishuju }}</div>
          <el-card class="bodtList">
            <!-- <eachartX/> -->
            <h1 style="padding: 0 0 40px 0">
              {{ dataObjs.shijian }}:{{ collecttime }}
            </h1>
            <el-table
              :data="tableData"
              border
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
            >
              <el-table-column
                prop="channelid"
                :label="dataObjsINfo.tongdaohao"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column :label="dataObjsINfo.yaosu" align="center">
                <template slot-scope="scope">{{
                  lang_file == "zh-cn"
                    ? scope.row.unittype
                    : scope.row.unittype_en
                }}</template>
              </el-table-column>
              <el-table-column :label="dataObjsINfo.shuzhi" align="center">
                <template slot-scope="scope">{{
                  scope.row.channeldata
                }}</template>
              </el-table-column>
              <el-table-column :label="dataObjsINfo.danwei" align="center">
                <template slot-scope="scope">{{ scope.row.unit }}</template>
              </el-table-column>
            </el-table>

            <!-- <div class="tble" v-for="(item,index) in letTable" :key="index">
              {{item.name}}
            </div>-->
          </el-card>
        </el-col>
        <el-col :span="19" style="padding: 0 0 0 5px">
          <div class="myMal">
            {{ dataObjs.shujuquxian }}
            <!-- <el-tooltip class="item" effect="dark" content="最大化" placement="top">
                <img
                  src="@/assets/img/ck.png"
                  style="width:35px;height:20px"
                  @click="lishData('数据曲线')"
                  alt="窗口化"
                />
            </el-tooltip>-->
          </div>
          <!-- <el-card class="bodtListnet1"> -->
          <div class="bodtListnet1">
            <eachartX
              v-if="flyLine"
              :xianchind="XianChind"
              :timechinner="TimeChild"
              :lowrlimt="lowrlimt"
              :lowerlimit="lowerlimit"
              :data-mix="dataMix"
              :typeunit="typeunit"
              :data-objs="dataObjs"
            />

            <div class="bneslit" v-if="flyLine">
              <el-radio-group v-model="channelidType" @change="channelidTypeL">
                <el-radio-button
                  :label="item.channelid"
                  v-for="item in channelidTtitle"
                  :key="item.channelid"
                  >{{
                    lang_file == "zh-cn" ? item.unittype : item.unittype_en
                  }}</el-radio-button
                >
              </el-radio-group>
            </div>
          </div>

          <!-- </el-card> -->
        </el-col>
      </el-row>
    </div>

    <!-- 弹框 -->
    <el-dialog
      :title="titleList"
      :visible.sync="centerDialogVisible"
      width="100%"
      center
      top="18vh"
      :modal="false"
    >
      <div class="map" style="height: 620px">
        <mapT v-if="titleList == '地图信息'" />
        <eachartX v-else />
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>

    <!-- 报警谭坤 -->
    <el-dialog
      :title="dataObjs.lixianwangguan"
      :visible.sync="centerDialogVisibleEdit"
      width="50%"
      center
    >
      <el-table
        :data="tableDataEnd"
        style="width: 100%"
        height="250"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column :label="dataObjs.wangguanmingcheng">
          <template slot-scope="{ row }">
            <span style="text-align: right; display: block">
              {{ row.dealername }}/{{ row.customername }}/{{
                row.areacount > 1 ? row.areaname + "/" : ""
              }}
              {{ row.name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="dataObjs.lixianbeizhu">
          <template slot-scope="scope">
            <el-form :model="scope.row">
              <el-form-item size="mini">
                <el-input
                  v-model="scope.row.offlineremark"
                  style="width: 100%; hight: 100%"
                ></el-input>
                <!-- <span v-else>{{ scope.row.channelname }}</span> -->
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisibleEdit = false">{{
          dataObjs.quxiao
        }}</el-button>
        <el-button type="primary" @click="add_ClickName">{{
          dataObjs.queding
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tree from "./componenth/tree";
import mapT from "./componenth/mapT";
import eachartZ from "./componenth/eachartZ";
import eachartX from "./componenth/eachartX";
import {
  adminIndex,
  getdata,
  homeData_index,
  getdataCnhannel,
  homeGetUid,
  lang_fend,
  getdataAreaH,
  baojingDataList,
  baojingBeizu,
  treeinfo,
  Longin,
} from "@/network/index";
import bus from "@/components/common/bus";
import echartsBing from "./componenth/echartsBing";
import echartsHx from "./componenth/echartsHx";
import { mapState } from "vuex";
export default {
  components: {
    tree,
    mapT,
    eachartZ,
    eachartX,
    echartsBing,
    echartsHx,
  },
  data() {
    return {
      tableDataEnd: [],
      formLabelAlign: {
        optname: "",
        optpassword: "",
        lang_file: "zh-cn",
      },
      centerDialogVisibleEdit: false,
      letTable: [],
      rightTabl: [],
      valueinsts: "",
      topTab: {},
      centerDialogVisible: false,
      titleList: "",
      tableData: [],
      lang_file: sessionStorage.getItem("lang_file"),
      roletype: sessionStorage.getItem("roletypeValue"),
      collecttime: "",
      defaultTree: [],
      XianChind: [],
      TimeChild: [],
      lowrlimt: [],
      lowerlimit: [],
      dataMix: [],
      channelidTtitle: [],
      channelidType: "",
      gateway_uuid: "",
      typeunit: "",
      month: "lastrow",
      dataObjs: {},
      dataObjsINfo: {},
      flyLine: true,
      options: [
        {
          value: "province",
          label: "省",
        },
        {
          value: "city",
          label: "市",
        },
        {
          value: "county",
          label: "区/县",
        },
        {
          value: "dealer_uuid",
          label: "经销商",
        },
        {
          value: "customer_uuid",
          label: "客户",
        },
        {
          value: "gateway_uuid",
          label: "网关",
        },
      ],
    };
  },
  computed: {
    ...mapState(["homeTree"]),
  },
  created() {
    document.onkeypress = (e) => {
      // 登录
      let akeyEnd = document.all ? event.keyCode : e.which;
      if (akeyEnd === 13) {
        this.regionClick("formLabelAlign");
      }
    };

    var afterUrl = window.location.search;

    if (afterUrl.indexOf("?") != -1) {
      //判断是否有参数
      var str = afterUrl.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
      var strs = str.split("="); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
      this.formLabelAlign.optname = strs[1]; //直接弹出第一个参数 （如果有多个参数 还要进行循环的）
    }
    // this.getCode()
    sessionStorage.setItem("lang_file", "zh-cn"); //缓存中文还是英文
    this.lang_file="zh-cn"
    sessionStorage.setItem("refreshtime", 30); //缓存中文还是英文
    sessionStorage.setItem("shshListData", "6F6822FF48C9F193B1FA792D55C1E045");
    this.getCookie();
    if (this.$route.query.code == undefined || this.$route.query.code == null) {
      this.getCode();
    }else{
      this.login();
    }
    

    // this.$notify({
    //   title: '标题名称',
    //   message: h('i', { style: 'color: teal'}, '这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案')
    // });
  },
  mounted() {
    // console.log(this.homeTree);
    // if(this.homeTree == ''){
    //     this.homeData_index();
    // }else{
    //   this.homeGetUid()
    //    this.defaultTree = [this.homeTree]; //给树默认值
    // }
  },
  methods: {
    getCode() {
      window.location.replace(
        "https://zsl.ixiamen.org.cn:8090/zsauth/oauth2/authorize?response_type=code&client_id=ZHGC&state=yuandao&redirect_uri=https:%2F%2Fwww.ousuiot.com%2Fhomepage"
      );
    },
    //   登录
    async login() {
      let optpassword = md5("888888");
      const res = await Longin("c2admin2738", optpassword.toUpperCase(), "1");
      let objs = {
        optname: this.formLabelAlign.optname,
        optpassword: optpassword.toUpperCase(),
      };
      this.$store.commit("formLabelAlign", objs);
      let { code, msg } = res;
      console.log(res);
      if (code) {
        sessionStorage.setItem("username", res.data.optname); //缓存taoken userName
        sessionStorage.setItem("isagree", res.data.roletype1); //缓存主账号还是子账号
        if (this.checked) {
          this.myoocs(
            this.formLabelAlign.optname,
            this.formLabelAlign.optpassword,
            7
          );
        } else {
          // 清空缓存
          this.clearCookie();
        }

        const { appid, roletype } = res.data;
        this.roletype = roletype;
        // this.$message.success("登陆成功");
        sessionStorage.setItem("token", appid); //缓存taoken
        console.log(sessionStorage.getItem("token"));
        //  this.$store.commit('roletypeValue',roletype)
        sessionStorage.setItem("roletypeValue", roletype); //保存当前用户的状态 0 平台 1经销商 2 客户
        // this.$router.push("/home");
        // this.myFengTuClickAll()  //全部刷新
        // this.handsetCount();
        // this.getdataAreaSelect()

        this.gitAXIOS();

        this.homeData_index();
        
        this.adminIndex();
        this.ShebeiData();
        this.zaixianData();
        this.lang_fend();
        this.baojingDataList();
      } else {
        this.clearCookie();
        this.$message.error(msg);
      }
    },
    //翻译
    async lang_fendInt() {
      let page = "gateway_channel_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.Dodata = data;
    },
    //获取cookie
    getCookie() {
      // console.log(document.cookie.length);
      if (document.cookie.length > 23) {
        this.checked = true;
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "optname") {
            this.formLabelAlign.optname = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "optpassword") {
            this.formLabelAlign.optpassword = arr2[1];
          }
        }
      }
    },
    //删除cookie
    clearCookie() {
      // alert('111')
      this.checked = "";
      this.myoocs("", "", -1); //修改2值都为空，天数为负1天就好了
      this.formLabelAlign = {};
    },
    // 中英文切换
    uend_end() {
      let login_page = "login_page";
      axios({
        url: swart + "/Index/trans_page",
        params: {
          page: login_page,
          lang_file: this.lang_file,
        },
        method: "post",
      }).then((res) => {
        console.log(res.data.data);
        this.dataObj = res.data.data;
      });
    },
    // 登陆验证
    regionClick(formName) {
      sessionStorage.setItem("lang_file", this.lang_file || "zh-cn"); //缓存中文还是英文
      this.$refs[formName].validate(async (valid) => {
        // console.log(valid);
        if (valid) {
          let optpassword = md5(this.formLabelAlign.optpassword);
          let clienttype = 1;
          const res = await Longin(
            this.formLabelAlign.optname,
            optpassword.toUpperCase(),
            clienttype
          );
          let objs = {
            optname: this.formLabelAlign.optname,
            optpassword: optpassword.toUpperCase(),
          };
          this.$store.commit("formLabelAlign", objs);
          console.log(res);

          let { code, msg } = res;
          // console.log(msg);
          if (code) {
            sessionStorage.setItem("username", res.data.optname); //缓存taoken userName
            sessionStorage.setItem("isagree", res.data.roletype1); //缓存主账号还是子账号
            if (this.checked) {
              this.myoocs(
                this.formLabelAlign.optname,
                this.formLabelAlign.optpassword,
                7
              );
            } else {
              // 清空缓存
              this.clearCookie();
            }

            const { appid, roletype } = res.data;
            // this.$message.success("登陆成功");
            sessionStorage.setItem("token", appid); //缓存taoken
            //  this.$store.commit('roletypeValue',roletype)
            sessionStorage.setItem("roletypeValue", roletype); //保存当前用户的状态 0 平台 1经销商 2 客户
            this.$router.push("/home");
          } else {
            this.clearCookie();
            this.$message.error(msg);
          }
        }
      });
    },
    //设置cookie
    myoocs(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      document.cookie =
        "optname=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "optpassword=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
    },

    // 获取离线设备信息
    async baojingDataList() {
      const { code, data } = await baojingDataList();
      // console.log(data);

      this.tableDataEnd = data;
    },
    // 报警确定按钮
    async add_ClickName() {
      // console.log(this.tableDataEnd);
      let gatewaylist = JSON.stringify(this.tableDataEnd);
      const { code, data, msg } = await baojingBeizu(gatewaylist);
      // console.log(msg);
      if (code) {
        this.$message.success(msg);
        this.baojingDataList();
        this.centerDialogVisibleEdit = false;
      }
    },
    // 弹出框
    delciEnt(name) {
      if (name != "guzhang") {
        this.centerDialogVisibleEdit = true;
      }
    },
    mycityHande(e) {
      // this.treeVlue = e
      console.log(e)
      this.$refs.Tabtree.mycityHande(e);
    },
    // 打开默认选项
    countClickTree(treeValue) {
      this.defaultTree = treeValue;
    },
    // 翻译
    async lang_fend() {
      let page = "home_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      this.dataObjs = data;
    },
    // table表格
    getUuidclick(e) {
      this.gateway_uuid = e;
      this.$store.commit("homeClick", e);
      this.homeGetUid();
    },
    async homeGetUid() {
      const { data } = await homeGetUid(this.homeTree);
      console.log(data);

      this.collecttime = data.channelinfo[0].collecttime;
      this.tableData = data.channelinfo;
      this.flyLine = true;
      // 获取通道号
      let titleInfoOUt = [];
      data.channelinfo.forEach((item) => {
        if (
          item.unittype != "风向" &&
          item.unittype != "最大降雨量" &&
          item.unittype != "最小降雨量" &&
          item.unittype != "最大降雨时间"
        ) {
          titleInfoOUt.push(item);
        }
      });
      this.channelidTtitle = titleInfoOUt;
      let dateset = this.month;
      // this.channelidType = titleInfoOUt[0].channelid//选中按钮状态
      this.getdataCnhannel(
        this.gateway_uuid,
        titleInfoOUt[0].channelid,
        dateset
      );
    },
    // 点击按钮
    channelidTypeL(e) {
      let dateset = this.month;
      this.getdataCnhannel(this.gateway_uuid, e, dateset);
    },
    // 默认实时数据
    async homeData_index() {
      this.defaultTree = [];
      let titleInfoOUt = [];
      const { data, msg } = await homeData_index();

      this.tableData = data.data.channelinfo; //数据

      this.collecttime = data.collecttime; //时间
      // console.log(data);
      data.data.channelinfo.forEach((item) => {
        if (
          item.unittype != "风向" &&
          item.unittype != "最大降雨量" &&
          item.unittype != "最小降雨量" &&
          item.unittype != "最大降雨时间"
        ) {
          titleInfoOUt.push(item);
        }
      });
      this.channelidTtitle = titleInfoOUt;
      let defaultTree = data.default.length - 1;
      let treeINfo = [];
      treeINfo.push(data.default[defaultTree].uuid);
      this.defaultTree = treeINfo; //给树默认值

      this.gateway_uuid = data.gateway_uuid;
      let dateset = this.month;
      this.getdataCnhannel(data.gateway_uuid, data.defaultchannelid, dateset);
    },
    async gitAXIOS() {
      let page = "home_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);
      this.dataObjsINfo = data;
    },
    // 这线图数据
    async getdataCnhannel(gateway_uuid, channelid, dateset) {
      this.lowrlimt = [];
      this.lowerlimit = [];

      const { data, msg } = await getdataCnhannel(
        gateway_uuid,
        channelid,
        dateset
      );

      if (data == "") return (this.flyLine = false);

      let wgChannelid = []; //折线图  线
      let timeChanne = []; //时间
      if (data.list) {
        data.list.forEach((element) => {
          wgChannelid.push(element.channeldata);
          timeChanne.push(element.collecttime);
        });
        this.XianChind = wgChannelid;

        this.TimeChild = timeChanne;
      }

      // 获取上限下限
      let datas = [];
      let channelidEnd = "";
      let typeunit = "";
      data.channelinfo.forEach((item) => {
        // console.log(item);
        channelidEnd = item.channelid;
        typeunit = item.unit;
        datas.push(
          {
            lte: Number(item.lowerlimit), //小于等于  gte//大于等于   //gt大于   //lt小于
            color: "blue",
          },
          {
            gt: Number(item.lowerlimit),
            lte: Number(item.upperlimit),
            color: "green",
          },
          {
            gt: Number(item.upperlimit),
            color: "red",
          }
        );
        this.lowrlimt.push(
          //  {type: 'average', name: '平均值'},
          // {
          //   type: "average",
          //   name: "平均值",
          //   label: {
          //     formatter: "平均值",
          //   },
          //   lineStyle:{
          //     color:'#e6a23c',
          //       curveness: 0.15,
          //   }
          // },
          {
            type: "average",
            name: "平均值",
            valueDim: "y",
            // label:'平均值',
            lineStyle: {
              color: "#e6a23c",
              curveness: 0.15,
            },
          },
          {
            yAxis: item.upperlimit, //上限
            //名字
            label: {
              formatter: "上限",
            },
            lineStyle: {
              color: "red",
              curveness: 0.15,
            },
          },
          {
            yAxis: item.lowerlimit, //下限
            label: {
              formatter: "下限",
            },
            lineStyle: {
              curveness: 0.15,
              color: "blue",
            },
          }
        );
        //没有用
        // this.lowerlimit.push({
        //   yAxis: item.lowerlimit, //下限
        // });
      });
      this.channelidType = channelidEnd; //选中按钮状态
      this.dataMix = datas; //给折线图标颜色
      this.typeunit = typeunit; //状态
    },
    // 实时数据查询
    // async getdata() {
    //   const { data, msg } = await getdata();
    // },
    // 用户信息
    async adminIndex() {
      let position = 1;
      let { code, data } = await adminIndex(position);
      this.letTable = data;
    },
    // 设备信息
    async ShebeiData() {
      let position = 2;
      let { code, data } = await adminIndex(position);
      this.rightTabl = data;
    },
    //在线情况
    async zaixianData() {
      let position = 3;
      let { code, data } = await adminIndex(position);
      this.topTab = data;
      this.$refs.echartsBing.echarBing(data);
    },
    // 地图信息 和 折线数据
    lishData(e) {
      this.centerDialogVisible = true;
      this.titleList = e;
    },
  },
};
</script>
<style scoped>
.tble {
  border-bottom: 1px solid #eeeeee;
  text-align: left;
  padding: 10px 20px;
  overflow: auto;
}
.eacharts {
  display: flex;
  /* height: 300px; */
  /* background: red; */
  /* margin-top:9px ; */

  /* justify-content: space-between; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  /* padding-bottom: 120px; */
}
.eachr {
  width: 33.3%;
  /* height: 370px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  /* padding-bottom: 30px; */
}
.ealistCent {
  width: 35%;
  /* height: 370px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.ealist {
  width: 28%;
  /* height: 370px; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.back {
  width: 100%;
  height: 200px;
  /* background: #040f3c; */
  /* height: 100%; */
  /* background: red; */
  /* overflow: auto; */
}
.warpbaox {
  height: 100%;
  display: flex;
  justify-content: space-between;
  height: 85px;
  align-items: center;
  background: #2d8cf0;
}
.user {
  width: 40px;
  text-align: center;
  flex: 1;
}
.count {
  background: #ffffff;
  height: 100%;
  width: 68%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* .count .el-link--inner{
  font-size: 22px !important;
} */
.nub {
  font-size: 40px;
  font-weight: 700;
  color: #2d8cf0;
}

.name {
  font-size: 18px;
  color: #999;
}
.ditu {
  width: 100%;
  /* background: #999; */
  /* height: 20px; */
  text-align: center;
  margin: 20px 0;
}
.bodtList {
  height: 350px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  overflow: auto;
}
.bodtListnet {
  height: 350px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  overflow-x: auto;
}
.bodtListnet1 {
  height: 350px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  overflow-y: auto;
}
::-webkit-scrollbar {
  width: 1px !important;
  height: 1px !important;
  /**/
}
.bneslit {
  /* display: flex; */
  /* flex-wrap: nowrap; */
  /* white-space:nowrap; */
}
.bodt {
  /* border: 1px solid red; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: 380px;
  overflow: auto;
}
.bodtConetne {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: 380px;
  overflow: hidden;
}
.myMal {
  /* text-align: left; */
  padding: 5px 0px 5px 20px;
  background: #5cb6d9;
  border-bottom: 1px solid #ccc;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin: 0 0 0 1px;
}
.selectOnints {
  position: absolute;
  left: 5%;
}
.myMal span {
  padding: 0px 4px;
  position: relative;
}
.hovEnt :hover {
  cursor: pointer;
}
</style>


